import { useMemo } from 'react';
import {
  getBrowserExperienceApiClient,
  ExperienceApiClientOptions,
} from '@repo/experience-api-client';
import { useRouter } from 'next/router';
import { headersWithXTestContextIdFrom } from '../utils/headers/xTestContextId';
import { headersWithXGoustoPlatform } from '../utils/headers/xGoustoPlatform';
import { EXPERIENCE_API_CLIENT_USER_AGENT_SERVICE } from '../utils/constants';
import applicationVersion from '../application-version.json';

export function useExperienceApiClient(
  clientOptions?: Omit<ExperienceApiClientOptions, 'baseUrl' | 'fetch'>,
) {
  const router = useRouter();
  return useMemo(
    () =>
      getBrowserExperienceApiClient({
        ...clientOptions,
        headers: {
          ...clientOptions?.headers,
          ...headersWithXTestContextIdFrom(router.query),
          ...headersWithXGoustoPlatform(router.query),
        },
        userAgent: {
          service: EXPERIENCE_API_CLIENT_USER_AGENT_SERVICE,
          version: applicationVersion.gitHash,
        },
      }),
    [clientOptions, router.query],
  );
}
